import React, { useState, useEffect, useMemo } from 'react';
import { useAppDispatch } from 'redux/hooks';

import styled from 'styled-components';
import { sub } from 'date-fns';

import { Grid, Divider as MuiDivider, Typography as MuiTypography } from '@mui/material';

import { spacing } from '@mui/system';

import Breadcrumbs from 'components/Breadcrumbs';
import StandardPageHeader from 'components/StandardPageHeader';

import { integrationHealthIsoStateIds } from '@constants';

import { fetchIntegrationHealth } from 'thunk';
import useTeams from 'hooks/useTeams';

import useUrl from 'hooks/useUrl';
import useAppNavigation from 'hooks/useAppNavigation';
import useIntegrationHealthData from 'hooks/useIntegrationHealthData';
import useIntegrationHealthTable from 'hooks/useIntegrationHealthTable';
import { getIntegrationDetailsDeepLinkUrl, formatIntegrationHealthDateParams } from 'utils';
import { integrationHealthIsoStateModifiers } from 'IntegrationModule/utils';

const Divider = styled(MuiDivider)(spacing as any);

const Typography = styled(MuiTypography)(spacing);

const defaultBreadCrumbItems = [
  {
    text: 'Teams',
    to: '/',
  },
];

const fetchIntegrationHealthDefaultArgs = {
  // limit: 90,
  // offset: 0,
  dateFromNow: 90,
};

function IntegrationHealth() {
  const dispatch = useAppDispatch();
  const { integration, targetServiceId, targetService, teamId } = useUrl();
  const { navigateToGeneralIntegrationPage } = useAppNavigation();
  const { TableComponent: IntegrationHealthTable } = useIntegrationHealthTable({
    targetService,
    targetServiceId,
    teamId,
    hideShowAll: true,
    hidePagination: true,
  });
  const { fetchTeams, teamHash } = useTeams();

  // Fetch all 90
  useEffect(() => {
    if (integration && targetServiceId && targetService && teamId) {
      dispatch(
        fetchIntegrationHealth({
          targetService,
          targetServiceIds: [targetServiceId],
          serviceNames: [targetService],
          startDate: formatIntegrationHealthDateParams(
            sub(new Date(), {
              days: fetchIntegrationHealthDefaultArgs.dateFromNow,
            }),
          ),
          endDate: formatIntegrationHealthDateParams(new Date()),
          isoStateId: integrationHealthIsoStateIds.IntegrationHealthTable,
          isInitialFetch: true,
          modifier:
            integrationHealthIsoStateModifiers[integrationHealthIsoStateIds.IntegrationHealthTable],
        }),
      );
      fetchTeams({ teamIds: [teamId] });
    } else {
      navigateToGeneralIntegrationPage();
    }
  }, [
    integration,
    targetServiceId,
    navigateToGeneralIntegrationPage,
    dispatch,
    targetService,
    teamId,
    fetchTeams,
  ]);

  return (
    <React.Fragment>
      <StandardPageHeader
        title="Integration Health"
        subtitle="Monitor integration status and health metrics"
        icon="Integration"
        sx={{ mb: 6 }}
      />

      <IntegrationHealthTable />

      <Divider sx={{ my: 6 }} />
    </React.Fragment>
  );
}

export default IntegrationHealth;
